var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOops(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 465,
    height: 201,
    viewBox: "0 0 465 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.972 26.6637C167.073 -1.26573 116.233 20.6788 120.22 56.588C82.3399 56.588 73.368 105.464 110.252 118.432C92.3089 160.326 147.136 184.265 186.013 158.331C201.963 188.255 261.775 199.228 299.655 158.331C322.583 188.255 383.391 174.291 383.391 127.409C422.269 127.409 430.244 60.5779 383.391 56.588C385.385 23.6712 349.498 1.72672 309.624 26.6638C277.724 -13.2354 216.916 -4.25816 198.972 26.6637Z",
    fill: "#D89F5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M408.313 37.6358C417.285 13.6963 456.162 -3.26067 463.14 9.70644C469.579 21.6713 428.25 21.6762 408.313 37.6358Z",
    fill: "#D89F5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M412.3 148.356C438.219 155.338 479.09 190.25 460.149 200.225C446.759 207.276 433.234 164.316 412.3 148.356Z",
    fill: "#D89F5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3495 133.394C49.4437 142.371 -6.38032 167.308 0.597686 175.288C6.18009 181.672 55.4249 150.018 79.3495 133.394Z",
    fill: "#D89F5B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.293 39.6308C83.337 21.6762 42.4658 7.71148 40.4721 15.6913C37.902 25.9781 84.9984 29.656 97.293 39.6308Z",
    fill: "#D89F5B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.359 175.288C67.3872 185.263 71.3747 197.232 84.3338 191.248C97.293 185.263 89.3181 172.295 76.359 175.288Z",
    fill: "#D89F5B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4281 56.588C45.4564 63.5703 53.4312 68.5577 58.4155 65.5652C63.3998 62.5728 62.4029 56.588 54.4281 56.588Z",
    fill: "#D89F5B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M299.655 191.248C295.668 194.24 297.662 203.217 303.643 200.225C309.624 197.232 308.627 188.255 299.655 191.248Z",
    fill: "#D89F5B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M440.212 62.5728C444.2 67.5602 455.165 80.3279 463.14 71.5501C468.577 65.5652 445.197 56.5879 440.212 62.5728Z",
    fill: "#D89F5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOops);
export default __webpack_public_path__ + "static/media/oops.0b3838b7ddbf6779e013c83646683fde.svg";
export { ForwardRef as ReactComponent };